import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { faFloppyDisk, faNetworkWired, faTag, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";

//APP
import { localConfig } from "../../../../../../../../../../Configs/localConfig";
import { obterCodLancamento, obterCodPorId, obterValorLancamento } from "../../../../../../meta";
import { ItemAtivoCadastrado } from "../../../../../../../../../../services/recomendacao/ativos/novo-index";
import { useDeleteCompatibilidade } from "../../../../../../../../../../services/recomendacao/ativos/delete";
import { usePostIncompatibilidade } from "../../../../../../../../../../services/recomendacao/ativos/post";
import { obterIdCompatibilidadePorId, obterValor } from "../../meta";

//COMPONENTS
import Input from "../../../../../../../../../../Components/CustomUi/input";
import TextArea from "../../../../../../../../../../Components/CustomUi/textarea";
import ButtonCustom from "../../../../../../../../../../Components/ButtonCustom";
import { Nivel } from "../nivel";
import { Inline } from "../../../../../../../../../../Components/CustomUi/inline";
import { obterTipoPorId } from "../../../compatibilidades/meta";

//PROPS
interface Props {
    registros: ItemAtivoCadastrado;
    onClose?: Function;
    atualizarLista?: Function;
    atualizarListaPrincipal?: Function;
    isVisualizar?: boolean;
    refetch?: Function;
    id_tipo_principal: number | null;
}
export const ModalEditar: React.FC<Props> = ({ registros, id_tipo_principal, onClose, atualizarLista, isVisualizar, refetch, atualizarListaPrincipal }) => {

    //STATES
    const [obs, setObs] = useState<string>('');
    const [cod_alerta, setCod_alerta] = useState<number>();
    const [original_cod_alerta, setOriginal_cod_alerta] = useState<number>();
    const [original_obs, setOriginal_obs] = useState<string>('');
    const [openConfirm, setOpenConfirm] = useState<boolean>(false);

    //API
    const { carregando_salvar_incompati, mutate_salvar_incompati } = usePostIncompatibilidade();
    const { carregando_deletar_compati, mutate_deletar_compati } = useDeleteCompatibilidade();

    function salvarEdicao() {
        mutate_salvar_incompati({
            codConta: Number(localConfig().conta),
            cod: registros?.cod,
            id_tipo_principal: registros?.lancamento,
            id_item_principal: registros?.[obterCodPorId(registros?.lancamento)],
            id_estadio_principal: registros?.estadio_cultura,
            cod_ativo: registros?.cod_ativo,
            cod_alerta: cod_alerta,
            tipo_compatibilidade: registros?.item_lancamento,
            cod_compatibilidade: obterIdCompatibilidadePorId(registros?.item_lancamento, registros),
            cod_estadios: registros?.cod_estadio ? [registros.cod_estadio] : undefined,
            obs: obs,
            limparStates: () => onClose?.(),
            atualizarLista: () => atualizarLista?.(),
            atualizarListaPrincipal: () => atualizarListaPrincipal?.(),
        });
    }

    function deletarCompatibilidade() {
        mutate_deletar_compati({
            codConta: Number(localConfig().conta),
            cod: registros.cod,
            limparStates: () => {},
            atualizarLista: () => {refetch?.(); atualizarLista?.(); atualizarListaPrincipal?.()},
            closePopup: () => setOpenConfirm(false)
        })
    }

    useEffect(() => {
        setObs(registros?.observacao);
        setOriginal_obs(registros?.observacao);
        setCod_alerta(registros?.cod_alerta);
        setOriginal_cod_alerta(registros?.cod_alerta);
    }, [registros]);

    function desabilitarBtnSalvar() {
        if (carregando_salvar_incompati) {
            return true;
        }
        if (isVisualizar) {
            return false;
        }
        return (original_obs === obs) && (original_cod_alerta === cod_alerta)
    }
    
    return (
        <div style={{display:'flex', flexDirection:'column', gap:15}}>
            
            <Inline gap={15}>
                <Input 
                    label="Tipo"
                    value={obterTipoPorId(registros?.[obterCodLancamento(registros.lancamento, id_tipo_principal)])}
                    onChange={()=>{}}
                    placeholder="Selecione o tipo"
                    icon={faNetworkWired}
                    desabilitado
                />
                <Input 
                    label={obterTipoPorId(registros?.[obterCodLancamento(registros.lancamento, id_tipo_principal)])}
                    value={registros?.[obterValorLancamento(registros.lancamento, id_tipo_principal)]}
                    onChange={()=>{}}
                    placeholder="Selecione o tipo"
                    icon={faTag}
                    desabilitado
                />
            </Inline>

            {registros.item_lancamento !== 6 && registros.item_lancamento !== 7 &&(
                <Inline gap={15}>
                    <Input 
                        label="Tipo"
                        value={obterTipoPorId(registros?.item_lancamento)}
                        onChange={()=>{}}
                        placeholder="Selecione o tipo"
                        icon={faNetworkWired}
                        desabilitado
                    />
                    <Input 
                        label={obterTipoPorId(registros?.item_lancamento)}
                        value={registros?.item_lancamento_nome}
                        onChange={()=>{}}
                        placeholder="Selecione o tipo"
                        icon={faTag}
                        desabilitado
                    />
                </Inline>
            )}
            
            

            {registros.cod_cultura !== null &&(
                <Inline gap={15}>
                    <Input 
                        label="Cultura"
                        value={registros.cultura_item_lancamento}
                        onChange={()=>{}}
                        placeholder="Selecione o tipo"
                        icon={faNetworkWired}
                        desabilitado
                    />
                    <Input 
                        label="Estádio"
                        value={registros.item_lancamento_nome ?? 'Todos'}
                        onChange={()=>{}}
                        placeholder="Selecione o tipo"
                        icon={faTag}
                        desabilitado
                    />
                </Inline>
            )}
            
            <Nivel
                id_nivel_de_incompatibilidade={cod_alerta}
                setId_nivel_de_incompatibilidade={setCod_alerta}
            />

            <TextArea
                label={`Observação da compatibilidade`}
                placeholder='Digite aqui a observação'
                value={obs}
                onChange={setObs}
                resize={false}
                height={70}
            />

            <Inline justifyContent={isVisualizar ? 'space-between' :"flex-end"} reverse={isVisualizar}>
                {isVisualizar ? 
                    <Popconfirm
                        placement="topRight"
                        title={'Tem certeza que deseja deletar este item?'}
                        open={openConfirm}
                        description={
                        <div style={{display:'flex',flexDirection:'column',gap:15}}>
                            <span>o item <b><i>{obterValor(registros)}</i></b> será deletado!</span>
                            <Inline justifyContent="flex-end">

                                <ButtonCustom 
                                    onClick={()=>{setOpenConfirm(false)}}
                                    type="tertiary"
                                    icon={<FontAwesomeIcon icon={faXmark} />}
                                    disabled={carregando_deletar_compati}
                                >
                                    Cancelar
                                </ButtonCustom>

                                <ButtonCustom 
                                    onClick={()=>{deletarCompatibilidade()}}
                                    icon={<FontAwesomeIcon icon={faTrash} />}
                                    danger
                                    loading={carregando_deletar_compati}
                                    disabled={carregando_deletar_compati}
                                >
                                    Deletar
                                </ButtonCustom>

                            </Inline>
                        </div>}
                        okButtonProps={{style: {display:'none'}}}
                        cancelButtonProps={{style: {display:'none'}}}
                    >
                        <Button style={{background:'transparent', padding:0, margin:0, border:'none', boxShadow:'none'}}>
                            <ButtonCustom
                                onClick={()=>{setOpenConfirm(true)}}
                                icon={<FontAwesomeIcon icon={faTrash} />}
                                type="secondary"
                                danger
                            >Deletar</ButtonCustom>  
                        </Button>
                    </Popconfirm>
                :
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faXmark}></FontAwesomeIcon>}
                        onClick={()=>{onClose(false)}}
                        type="tertiary"
                        danger
                        disabled={carregando_salvar_incompati}
                    >
                        Cancelar
                    </ButtonCustom>
                }
                
                <ButtonCustom 
                    icon={<FontAwesomeIcon icon={faFloppyDisk}></FontAwesomeIcon>}
                    onClick={()=>{salvarEdicao()}}
                    loading={carregando_salvar_incompati}
                    disabled={desabilitarBtnSalvar()}
                >
                    Salvar edição
                </ButtonCustom>
            </Inline>

        </div>
    )
};